import request from './business-api'
export function login(data:any) {
    return request({
        url: '/web/api/login',
        method: 'post',
        data
    })
}


export function add(data:any) {
    return request({
        url: 'api/rSource',
        method: 'post',
        data
    })
}

export function edit(data:any) {
    return request({
        url: 'api/rSource',
        method: 'put',
        data
    })
}

export function del(id:any) {
    return request({
        url: 'api/rSource/' + id,
        method: 'delete'
    })
}

export function rSourceAll(params:any) {
    return request({
        url: 'api/rSource/all',
        method: 'get',
        params
    })
}

export function getClassList(params:any) {
    return request({
        url: '/web/api/getClassRoomList',
        method: 'get',
        params
    })
}
export function getHeathStatus() {
    return request({
        url: '/web/api/isHealth',
        method: 'get',
    })
}


export async function getRtcToken(data:any) {
    return await request({
        url: '/web/api/getRtcToken',
        method: 'post',
        data
    })
}


export async function getRtmToken(data:any) {
    return await request({
        url: '/web/api/getRtmToken',
        method: 'post',
        data
    })
}
